import * as React from "react"
import { Link } from "gatsby"

import Container from "../container/container"

import * as styles from "./info.module.scss"

import Markdown from "react-markdown"

const InfoSection = props => {
  return (
    <div className={styles.info}>
      <Container>
        <div
          className={`d-flex align-items-center justify-content-between ${styles.info__wrap}`}
        >
          <div className={styles.info__section}>
            <h2>{props.data.ListHeading}</h2>
            <Markdown>{props.data.ListBody}</Markdown>
          </div>
          <div className={styles.info__section}>
            <div className={styles.info__section__image}>
              <div className={styles.info__section__image__bg}></div>
              <img
                src={props.data.ListImage.publicURL}
                alt={props.data.ListHeading}
              />
            </div>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default InfoSection
